import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input({ required: true }) btnBgColor: string;
  @Input({ required: false }) btnTextColor: string = '';
  @Input({ required: true }) btnHoverBgColor: string;
  @Input({ required: false }) btnHoverTextColor: string = '';
  @Input({ required: false }) label?: string;
  /** للأزرار ذات الأيقونة فقط؛ يُفضَّل مع عنوان شاشة عند عدم وجود label */
  @Input({ required: false }) ariaLabel?: string;
  @Input({ required: false }) icon?: string;
  @Input({ required: false }) disable = false;
  @Input({ required: false }) isLoading = false;
  @Input({ required: false }) padding = '10px';
}
